const tableDetails = {
  country: "Land",
  freePilot:"",
  companyDisplayName: "Firma",
  numberOfNights: "Anzahl der Nächte",
  license: "Lizenz",
  pricePerKm: "Preis pro km",
  street: "Straße",
  licenses: "Lizenzen",
  startDateOffer: "Pilot verfügbar ab",
  endDateOffer: "Angebotsende",
  maxRadiusToStartInKm: "Maximale Entfernung [km]",
  subscriptionEndDate: "Abonnement (bis)",
  driverLicenseType: "Lizenztyp",
  vin: "VIN",
  myOffer: "Mein Angebot",
  statusAndDeadline: "Frist",
  companyLowestOffer: "Niedrigstes Angebot",
  customName: "Benutzerdefinierter Name",
  created_at: "Registrierungsdatum",
  technicalReviewExpirationDateFrom: "Technische Prüfung (von)",
  technicalReviewExpirationDateTo: "Technische Prüfung (bis)",
  insurancePolicyWillRunOutSoon: "Versicherung läuft bald ab",
  daysLeft: "Verbleibende Tage",
  note: "Notiz",
  userName: "Name",
  paidDate: "Zahlungsdatum",
  isVerified: "Verifiziert",
  bidThreshold: "",
  Nr: "Nummer",
  paid: "Bezahlt",
  driverEmail: "E-Mail des Fahrers",
  userId: "Benutzer-ID",
  carStatus: "Status",
  modalAddWorker: "Administrator hinzufügen",
  carRegistrationNumber: "Kennzeichen",
  modalConfirmationWorkers: "Wähle eine Aktion für den Mitarbeiter:",
  btnAccept: "Bestätigen",
  messageTitle: "Notiz",
  originalname: "Dateiname",
  visible: "Öffentlich sichtbar",
  action: "",
  email: "E-Mail-Adresse",
  firstName: "Vorname",
  lastName: "Nachname",
  role: "Rolle",
  admin: "Manager",
  worker: "Mitarbeiter",
  owner: "Administrator",
  policyExpirationDate: "Versicherung läuft ab",
  carName: "Fahrzeugname",
  administrator: "Manager",
  modalConfirmationUser: "Wähle eine Aktion für den Benutzer:",
  modalConfirmationCompany: "Wähle eine Aktion für das Unternehmen:",
  modalConfirmationDepartment: "Wähle eine Aktion:",
  modalConfirmationAuthorization: "Wähle eine Aktion für die Autorisierung:",
  modalConfirmationCars: "Wähle eine Aktion für das Fahrzeug:",
  modalConfirmationDriver: "Wähle eine Aktion für den Fahrer:",
  nip: "Steuer-ID (NIP)",
  description: "Beschreibung",
  id: "ID",
  companyId: "ID",
  companyName: "Firmenname",
  companyCity: "Stadt",
  companyAddress: "Adresse",
  companyZipCode: "Postleitzahl",
  companyNip: "Steuer-ID",
  companyPhone: "Telefonnummer",
  factoringCommission: "Factoring-Provision",
  userPhone: "Telefonnummer",
  userCompany: "Rolle im Unternehmen",
  undefined: "",
  startDate: "Startdatum",
  endDate: "Enddatum",
  companyOwners: "Firmeninhaber",
  createdAt: "Erstellt am",
  addresses: "Firmenadressen",
  departments: "Abteilungen",
  warehouse: "Lager",
  driver: "Spediteur",
  factory: "Hersteller",
  templateName: "Vorlagenname",
  fullName: "Vollständiger Name",
  documentNumber: "Ausweisnummer",
  name: "Name",
  policy_lasting: "Versicherung gültig bis",
  surname: "Nachname",
  address: "Adresse",
  city: "Stadt",
  countryCode: "Ländercode",
  isAutomatic: "Automatische Autorisierung",
  zipCode: "Postleitzahl",
  phone: "Telefonnummer",
  managers: "Manager",
  avatar: "Profilbild",
  ownerInCompanies: "Inhaber der Firma:",
  status: "Status",
  type: "Typ",
  departmentPhone: "Telefonnummer",
  departmentAvatar: "Bild",
  department: "Abteilung",
  trailerNumber: "Anhänger-Nummer",
  semitrailerNumber: "Kennzeichen des Anhängers",
  registrationNumber: "Kfz-Kennzeichen",
  docType: "Dokumenttyp",
  carType: "Fahrzeugtyp",
  carPart: "Teiletyp",
  isDeleted: "Gelöscht",
  winningOffer: "Gewonnenes Angebot",
  gusConfirmed: "GUS-Übereinstimmung",
  hostIp: "Computer-IP",
  subId: "XLplanner-ID",
  incoming: "Eingehend",
  carrier: "Spediteur",
  monitaryDate: "Reservierungsdatum und -zeit",
  warehouseMonitoryNoteId: "XLplanner-Auftragsnummer",
  monitoryNoteNumberInWarehouse: "XLplanner-Auftragsnummer",
  company: "Firma",
  allowSms: "SMS erlaubt",
  phoneNumberVerified: "Telefonnummer verifiziert",
  companyWarehouseName: "Lagerverwalter",
  driverFullName: "Fahrer",
  modifiedAt: "Bestätigungsdatum und -zeit",
  lp: "Lfd. Nr.",
  invoiceDate: "Rechnungsdatum",
  userDepartment: "Mitarbeiter zugeordnet zu:",
  policyNumber: "Versicherungsnummer",
  carInsurer: "Versicherer",
  shortName: "Standortname",
  isMain: "Hauptsitz:",
  carNumber: "Kennzeichen",
  dateStart: "Avisierungsbeginn",
  dateEnd: "Avisierungsende",
  monitoryNoteNumber: "Avisierungsnummer",
  driverName: "Fahrer",
  destination: "Lager",
  driverPhone: "Telefonnummer des Fahrers",
  policyExpirationDateTo: "Versicherung gültig bis",
  policyExpirationDateFrom: "Versicherung gültig ab",
  factoring: "Factoring",
  editTableData: "Daten bearbeiten",
  consignmentNumber: "Sendungsnummer",
  cargos: "Ladungen",
  length: "Anzahl der Mitglieder",
  orderNumber: "Auftragsnummer",
  monitoryNoteStatus: "Zeitfenster",
  cargoLoads: "Beladung",
  cargoUnloads: "Entladung",
  companyLoader: "Auftraggeber",
  verification: "Verifizierung",
  isAccountVerified: "E-Mail-Verifizierung",
  startingPrice: "Startpreis",
  deadline: "Frist",
  remarks: "Zusätzliche Informationen",
  currency: "Währung",
  participantsNumber: "Anzahl der Teilnehmer",
  lastAuctionPost: "Datum der letzten Ausschreibung",
  numberOfCargo: "Ladestellen",
  numberOfLoads: "Start",
  numberOfUnoads: "Anzahl der Entladungen",
  departmentLoader: "Ausstellende Abteilung",
  auctionType: "Auktionstyp",
  defaultPaymentDeadlineDays: "Standard-Zahlungstag",
  email_verified: "Benutzer hat die E-Mail-Verifizierung bestätigt",
  email_unverified: "Benutzer hat die E-Mail-Verifizierung nicht bestätigt",
  firstDownloadedAt: "Erstmals heruntergeladen",
  lng: "Längengrad",
  lat: "Breitengrad",
  rampsCreated: "Rampen hinzugefügt",
  startPoint: "Start",
  endPoint: "Ziel",
  numberOfUnloads: "Anzahl der Entladungen",
  isOutside: "Extern",
  startHour: "Startzeit",
  endHour: "Endzeit",
  date: "Datum",
  driverDocument: "Fahrerdokumentnummer",
  departmentsLength: "Mitglieder",
  download: "",
  auctionOffers: "Anzahl der Angebote",
  startAucDate: "Startdatum",
  invoiceId: "Rechnungsnummer",
  surcharges: "Zuschläge",
  auctionId: "Auktions-ID",
  lowestOffer: "Niedrigstes Angebot",
  verificationTransferConfirmed: "Transfer bestätigt",
  verificationTransferData: "Verifizierungsdaten von P24",
  departmentNameForDepartmentList: "Name",
  workerName: "Vorname",
  ramp: "Rampe",
  likes: "Positive Bewertungen",
  dislikes: "Negative Bewertungen",
  verificationTransferDate: "Erstellt am",
  policyStatus: "Versicherungsstatus",
  isFinished: "Abgeschlossen",
  pilot: "Pilot",
  driverLicense: "Lizenz",
  lang: "Sprache",

};

export default tableDetails;
